import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import featureFlag from './plugins/featureFlag';
import Notifications from '@kyvg/vue3-notification';

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(Notifications);
app.use(featureFlag);

router.isReady().then(() => {
  app.mount('#app');
});
